<template>
  <DatePicker
    ref="calendar"
    class="ts-date-picker"
    v-bind="$attrs"
    v-on="$listeners"
    is-inline
    :theme="theme"
  ></DatePicker>
</template>

<style lang="scss" scoped>
.ts-date-picker::v-deep {
  background-color: transparent;
  border-width: 0;

  &.vc-container {
    .vc-title {
      font-family: Roboto;
      font-size: 12px;
      color: #9aa5b7;
    }

    .vc-cursor-pointer {
      svg {
        height: 12px;
      }
    }

    .vc-weekday {
      font-family: Roboto;
      font-size: 10px;
      text-align: center;
      color: #9aa5b7;
    }

    .vc-day-content {
      font-family: Roboto;
      font-size: 12px;
      text-align: center;
      color: #6d7587;
    }

    .ts-date-picker-selection-temp {
      border-radius: 20px;
      border: solid 2px #99ffd1;
    }

    .ts-date-picker-selection-boundary {
      border-radius: 20px;
      box-shadow: inset 0 -4px 8px 0 rgba(235, 255, 247, 0.88), inset 0 4px 8px 0 rgba(24, 122, 92, 0.4);
      border: solid 1px rgba(235, 236, 240, 0.24);
      background-color: #99ffd1;
    }

    .ts-date-picker-selection-link {
      background-blend-mode: soft-light, normal;
      background-image: linear-gradient(286deg, #000000, #ffffff -1%), linear-gradient(to bottom, #ebecf0, #ebecf0);
    }
  }
}
</style>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';

export default {
  name: 'TsDatePicker',
  components: {
    DatePicker
  },
  data() {
    return {
      theme: {
        bgLow: {
          light: 'ts-date-picker-selection-temp'
        },
        bgAccentLow: {
          light: 'ts-date-picker-selection-link'
        },
        bgAccentHigh: {
          light: 'ts-date-picker-selection-boundary'
        }
      }
    };
  }
};
</script>
